import { NgModule } from '@angular/core';
import { TopbarComponent } from './topbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../shared/material.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	imports: [BrowserAnimationsModule, RouterModule, MaterialModule, TranslateModule],
	declarations: [TopbarComponent],
	exports: [TopbarComponent],
})
export class TopbarModule {}
